import { RouterProvider } from 'react-router-dom';

import { AppRoutes } from './routes/app-routes';

export default function App() {
  return <RouterProvider router={AppRoutes} />;
}
